'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FileInput = require('./FileInput');

var _FileInput2 = _interopRequireDefault(_FileInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileInputList = function (_Component) {
  _inherits(FileInputList, _Component);

  function FileInputList(props) {
    _classCallCheck(this, FileInputList);

    var _this = _possibleConstructorReturn(this, (FileInputList.__proto__ || Object.getPrototypeOf(FileInputList)).call(this, props));

    var filesUrls = {};

    props.items.forEach(function (item) {
      filesUrls[item.name] = item.initialValue;
    });

    _this.state = {
      filesUrls: filesUrls,
      files: {}
    };
    return _this;
  }

  _createClass(FileInputList, [{
    key: 'onDrop',
    value: function onDrop(name, file) {
      var _this2 = this;

      var files = _extends({}, this.state.files);
      files[name] = file;

      this.setState({ files: files }, function () {
        _this2.props.onDrop(name, file);
      });
    }
  }, {
    key: 'onRemove',
    value: function onRemove(name, file) {
      var _this3 = this;

      var key = this.state.files[name] === file ? 'files' : 'filesUrls';

      var files = _extends({}, this.state[key]);
      files[name] = undefined;

      this.setState(_defineProperty({}, key, files), function () {
        _this3.props.onRemove(name, file);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;

      var files = this.state.files;
      var filesUrls = this.state.filesUrls;

      return _react2.default.createElement(
        'div',
        { className: _classnames2.default.apply(undefined, ['field', { hidden: props.hidden }].concat(_toConsumableArray(props.customClassNames || []))) },
        props.bigLabel && _react2.default.createElement(
          'label',
          { className: 'bigLabel' },
          props.bigLabel
        ),
        _react2.default.createElement(
          'label',
          null,
          props.label
        ),
        _react2.default.createElement(
          'div',
          { className: 'fieldItemsContainer' },
          props.items.map(function (item, key) {
            return _react2.default.createElement(_FileInput2.default, {
              key: key,
              item: item,
              files: files,
              filesUrls: filesUrls,
              extraData: {},
              onDrop: _this4.onDrop.bind(_this4),
              onRemove: _this4.onRemove.bind(_this4)
            });
          })
        ),
        props.errors && props.errors.length > 0 && _react2.default.createElement(
          'label',
          { className: 'ui red basic label' },
          props.errors.map(function (error, key) {
            return _react2.default.createElement(
              'div',
              { key: key },
              error
            );
          })
        )
      );
    }
  }]);

  return FileInputList;
}(_react.Component);

FileInputList.propTypes = {
  name: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  bigLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  items: _propTypes2.default.array,
  type: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
  onDrop: _propTypes2.default.func,
  hidden: _propTypes2.default.bool,
  errors: _propTypes2.default.array,
  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

FileInputList.defaultProps = {
  type: 'text',
  initialValue: '',
  placeholder: ''
};

exports.default = FileInputList;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/FileInputList.js
// module id = 159
// module chunks = 0